import React from 'react'
import { Outlet } from 'react-router-dom'

const AccountSetting = () => {
  return (
    <>
      <section className='w-100 px-3 pt-3 overflow-y-scroll scrollbar-hidden' style={{ backgroundColor: '#ecf6fa' }}>
        {/* Header */}
        <div className='d-flex align-items-center justify-content-between gap-3 bg-light px-3 py-2 rounded-3'>
          <h4 className='mb-0'>Account Setting</h4>

          <select className="form-select w-auto">
            <option selected>Open this select menu</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>

        {/* Search */}
        <div className='d-flex align-items-center gap-2 ps-2 ps-sm-3 my-3 bg-light rounded-3'>
          <img src="/images/icons/search-black.svg" style={{ height: '20px' }} alt="search" />

          <input type="search" className='form-control border-0 shadow-none bg-transparent' placeholder='Search & Filter...' />
        </div>

        <Outlet />
      </section> 
    </>
  )
}

export default AccountSetting
